module.exports = __webpack_public_path__ + "wafuss2.f5ca875a85f1ce69374be21eceef389b.png";